__turbopack_context__.v({
  "deleteButton": "styles-module__5Clqha__deleteButton",
  "deleteText": "styles-module__5Clqha__deleteText",
  "spinner": "styles-module__5Clqha__spinner",
});
